import { PlusOutlined, QuestionCircleFilled } from "@ant-design/icons";
import { Tooltip } from "antd";
import styles from "../Interactive.module.scss";
import i18n from "i18next";

const ProductAddBadge = ({
  name,
  hint,
  onClick,
}: {
  name: string;
  hint?: string;
  onClick?: () => void;
}) => (
  <div className={styles.productBadge}>
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "row",
        columnGap: 12,
        flex: 1,
        justifyContent: "space-between",
      }}
    >
      <div className={styles.title}>{name}</div>
      {hint && (
        <Tooltip title={() => <div dangerouslySetInnerHTML={{ __html: hint }} />}>
          <QuestionCircleFilled className={styles.icon} />
        </Tooltip>
      )}
    </div>
    <div style={{ width: "100%", cursor: "pointer" }}>
      <div className={styles.button} onClick={onClick}>
        {i18n.t("widget.suggestionAdd")} <PlusOutlined />
      </div>
    </div>
  </div>
);

export default ProductAddBadge;
